import { FC } from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';

import { ALL_LIBRARY_SCOPES, LIBRARY_SCOPES } from '../constants';

import styles from '../styles.module.scss';

type LibraryScopePickerProps = {
  value: string[];
  onChange: (scopes: string[]) => void;
};

export const LibraryScopePicker: FC<LibraryScopePickerProps> = ({ value: libraryScopes, onChange }) => {
  const allLibrariesSelected = libraryScopes.length === LIBRARY_SCOPES.length;
  const toggleLibrary = (scope: string, checked: boolean) =>
    onChange(checked ? [...libraryScopes, scope] : libraryScopes.filter((s) => s !== scope));

  let selectionLabel = `${libraryScopes.length} of ${LIBRARY_SCOPES.length} selected`;
  if (libraryScopes.length === 0) selectionLabel = 'none selected';
  else if (allLibrariesSelected) selectionLabel = 'all selected';

  return (
    <div className={styles['scopes']}>
      <p className={styles['scopes-title']}>Access</p>
      <FormControlLabel
        disabled
        className={styles['locked-scope']}
        control={<Checkbox size="small" checked />}
        label={
          <span>
            SDK documentation <span className={styles['muted']}>always included</span>
          </span>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={allLibrariesSelected}
            indeterminate={libraryScopes.length > 0 && !allLibrariesSelected}
            onChange={(e) => onChange(e.target.checked ? ALL_LIBRARY_SCOPES : [])}
          />
        }
        label={
          <span>
            Libraries <span className={styles['muted']}>{selectionLabel}</span>
          </span>
        }
      />
      <div className={styles['scope-children']}>
        {LIBRARY_SCOPES.map(({ scope, label }) => (
          <FormControlLabel
            key={scope}
            control={
              <Checkbox
                size="small"
                checked={libraryScopes.includes(scope)}
                onChange={(e) => toggleLibrary(scope, e.target.checked)}
              />
            }
            label={label}
          />
        ))}
      </div>
      <p className={styles['muted']}>Library access also requires an active SDK subscription.</p>
    </div>
  );
};
